import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const t = localStorage.getItem("ct_token");
      if (!t) { setUser(null); setReady(true); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("ct_token");
        setUser(null);
      }
      setReady(true);
    })();
  }, []);

  const login = useCallback(async (role, identifier, password) => {
    const { data } = await api.post("/auth/login", { role, identifier, password });
    localStorage.setItem("ct_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ct_token");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
